module.exports = __webpack_public_path__ + "img/japanese-post-office.4f2a0107.png";